'use client';

import { type FC, useState } from 'react';
import { Button, BottomSheet, Input } from '../../../ui';
import { useLocalTranslation } from '../../../../hooks/useLocalTranslation';
import translations from '../RushMid.translations';

interface JoinByCodeSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onJoin: (code: string) => void;
}

export const JoinByCodeSheet: FC<JoinByCodeSheetProps> = ({ isOpen, onClose, onJoin }) => {
  const { t } = useLocalTranslation(translations);
  const [joinCode, setJoinCode] = useState('');

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={t('partyJoin')} heightClass="h-auto max-h-[85vh]">
      <div className="flex flex-col gap-3 px-4 pb-4">
        <Input
          value={joinCode}
          onChange={(e) => setJoinCode(e.target.value.toUpperCase())}
          placeholder={t('partyJoinPlaceholder')}
          maxLength={6}
          className="text-center font-mono text-lg tracking-[0.3em]"
        />
        <Button
          variant="primary"
          size="l"
          stretched
          disabled={joinCode.trim().length < 4}
          onClick={() => { onJoin(joinCode.trim()); onClose(); setJoinCode(''); }}
        >
          {t('partyJoinAction')}
        </Button>
      </div>
    </BottomSheet>
  );
};
